module.exports = __webpack_public_path__ + "static/6M_2025_Financial_Reporting-20fb05d7462e81d53f8539c1a9d8a0e2.pdf";